/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllOrganizationIPWhitelistResponseData } from './FindAllOrganizationIPWhitelistResponseData';
import {
    FindAllOrganizationIPWhitelistResponseDataFromJSON,
    FindAllOrganizationIPWhitelistResponseDataFromJSONTyped,
    FindAllOrganizationIPWhitelistResponseDataToJSON,
    FindAllOrganizationIPWhitelistResponseDataToJSONTyped,
} from './FindAllOrganizationIPWhitelistResponseData';

/**
 * 
 * @export
 * @interface FindAllOrganizationIPWhitelistResponse
 */
export interface FindAllOrganizationIPWhitelistResponse {
    /**
     * 
     */
    data?: FindAllOrganizationIPWhitelistResponseData;
}

/**
 * Check if a given object implements the FindAllOrganizationIPWhitelistResponse interface.
 */
export function instanceOfFindAllOrganizationIPWhitelistResponse(value: object): value is FindAllOrganizationIPWhitelistResponse {
    return true;
}

export function FindAllOrganizationIPWhitelistResponseFromJSON(json: any): FindAllOrganizationIPWhitelistResponse {
    return FindAllOrganizationIPWhitelistResponseFromJSONTyped(json, false);
}

export function FindAllOrganizationIPWhitelistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllOrganizationIPWhitelistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllOrganizationIPWhitelistResponseDataFromJSON(json['data']),
    };
}

export function FindAllOrganizationIPWhitelistResponseToJSON(json: any): FindAllOrganizationIPWhitelistResponse {
    return FindAllOrganizationIPWhitelistResponseToJSONTyped(json, false);
}

export function FindAllOrganizationIPWhitelistResponseToJSONTyped(value?: FindAllOrganizationIPWhitelistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllOrganizationIPWhitelistResponseDataToJSON(value['data']),
    };
}

